module.exports = __webpack_public_path__ + "img/studio图2.ed60510a.png";